import { render, staticRenderFns } from "./NormalSearchNav174.vue?vue&type=template&id=89b064ee&scoped=true&"
import script from "./NormalSearchNav174.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav174.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b064ee",
  null
  
)

export default component.exports